import React from 'react'
import PropTypes from 'prop-types'

import './status-message-label.pcss'

const StatusMessageLabel = ({ text, ...rest }) => {
    return (
        <div className="status-message-label" {...rest}>
            {text}
        </div>
    )
}

StatusMessageLabel.propTypes = {
    text: PropTypes.string.isRequired,
}

export default StatusMessageLabel
